import { useContext, useMemo } from 'react'

import config from 'constants/config'
import GeoContext from 'contexts/geoContext'

export const useTourV2SearchEnabled = () => {
  const { currentRegionCode } = useContext(GeoContext)
  return useMemo(() =>
    config.TOUR_V2_SEARCH_REGIONS_WHITELIST?.split(',').includes(currentRegionCode),
  [currentRegionCode])
}
